import { api } from '@api/api2';

const switchToCustomFields = () =>
  api.v1('post', 'tck/bms/metric/switch-to-custom-fields');

export const sduiNewVesion = {
  switchToCustomFields,
};
